import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FileDownloadService {
  download(url: string, fileName: string): void {
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Download failed with status ${response.status}`);
        }
        return response.blob();
      })
      .then((blob) => {
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(objectUrl);
      })
      .catch((error) => {
        console.error('Error downloading file:', error);
        // If fetch fails (e.g., CORS or network error), fall back to opening the URL directly.
        // This loses the ability to force a download with a custom filename.
        window.open(url, '_blank');
      });
  }
}
